import React, { useEffect, useRef } from "react";
import { WordMark } from "../Basic/WordMark";
import { Footer } from "../Basic/Footer";
import { Navbar } from "../Basic/NavBar";
import PortfolioPage from "./PortfolioData";


export default function ReadalPortFolio() {
    const glowRef = useRef(null);
    const rootRef = useRef(null);

      // Cursor glow
    useEffect(() => {
        const glow = glowRef.current;
        const onMove = (e) => {
          if (!glow) return;
          glow.style.left = e.clientX + "px";
          glow.style.top = e.clientY + "px";
        };
        window.addEventListener("mousemove", onMove);
        return () => window.removeEventListener("mousemove", onMove);
    }, []);

     // Scroll reveal
    useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const els = root.querySelectorAll(".reveal, .tl-item");
    const io = new IntersectionObserver(
        (entries) => {
        entries.forEach((en) => {
            if (en.isIntersecting) en.target.classList.add("in");
        });
        },
        { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
    }, []);

    return (
        <div ref={rootRef} className="readal-root">
            <div id="bg-grid"></div>
            <div id="noise"></div>
            <div className="cursor-glow" ref={glowRef}></div>

            <Navbar />
            <PortfolioPage />
            <WordMark />
            <Footer />
        </div>
    )
}